module.exports = __webpack_public_path__ + "assets/img/29_260_big.d2f3da94.jpg";